import { render, staticRenderFns } from "./creationrequests.vue?vue&type=template&id=235da178&scoped=true"
import script from "./creationrequests.vue?vue&type=script&lang=js"
export * from "./creationrequests.vue?vue&type=script&lang=js"
import style0 from "./creationrequests.vue?vue&type=style&index=0&id=235da178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235da178",
  null
  
)

export default component.exports